<div class="max-h-full flex flex-col gap-4 px-4 pt-4">
  @if (showLoader) {
    <app-loader />
  }
  <h3 class="m-0">{{pickDayText}}</h3>
  <div class="flex " [ngClass]="{ 'gap-2': isMobile, 'flex-col gap-4': !isMobile }">
    <app-day-picker (onDayPicked)="pickDay($event)" [selectedDay]="day$ | async" [ngStyle]="{'width': isMobile ? '50%' : '100%'}"/>
    <mot-time-picker [formControl]="timeControl" [label]="timeText" icon="clock"
      iconClass="text-2xl" class="w-full" [ngStyle]="{'width': isMobile ? '50%' : '100%'}"/>
    </div>
    @if (isDesktop) {
      <!-- contrast: #6f7277 ~4.3:1 fell just below AA 4.5:1; subText (#5C748F, ~4.9:1) passes. -->
      <span class="text-sm text-subText">{{typeTime24HoursText}}</span>
    }
    <app-search-station-detailed-result-routes-calendar-list [stopTimes]="stopTimes" [lines]="routesInStop.length > 0 ? routesInStop : stop.routesInStop"
      [routeSpecialMessages]="routeSpecialMessages" [stopCode]="stop.stopcode"
      class="flex-1 overflow-y-auto use-scrollbar px-1" (pickLineEvent)="pickLine($event)" [isToday]="isToday"
      [selectedDate]="getSelectedDate()" [selectedTime]="timeControl.value" />
    </div>
